import axios from '../axios';

export const show = (name, lang) => {
  return axios.get(`/seo/${name}?lang=${lang}`);
};

export const createOrUpdate = (payload) => {
  return axios.post('/seo', payload);
};
